import { render } from "./BattlesItemElement.vue?vue&type=template&id=1e630b3c&scoped=true"
import script from "./BattlesItemElement.vue?vue&type=script&lang=js"
export * from "./BattlesItemElement.vue?vue&type=script&lang=js"

import "./BattlesItemElement.vue?vue&type=style&index=0&id=1e630b3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e630b3c"]])

export default __exports__